import { Check, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import ServicesOverview from "./ServicesOverview";

function SmartHomeSection() {
  return (
    <>
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20 md:order-none">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg md:col-start-1 md:row-start-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Transparante prijzen – Geen verrassingen, alleen zekerheid!
            </h2>

            <p className="mb-6">
              Bij Elektra Aanleggen, leveren wij vakwerk tegen een eerlijke
              prijs. Of het nu gaat om elektra aanleggen, renovatie of het
              vervangen van uw groepenkast, wij zorgen voor een veilige en
              professionele installatie.
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Duidelijke prijsopgave zonder verrassingen!
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Telefonisch een indicatie van de kosten
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Bij interesse een schriftelijke offerte
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Voor grotere klussen een inspectiebezoek vooraf
                </span>
              </li>
            </ul>

            <p className="mb-6">
              Na akkoord plannen wij de werkzaamheden zorgvuldig in. Bij
              oplevering lopen we samen alles na om uw volledige tevredenheid te
              garanderen. U betaalt 50% direct per pin, de rest binnen 30 dagen
              via factuur – Zo bent u verzekerd van een transparant en eerlijk
              betalingsproces.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>

          <div className="block md:col-start-2 md:row-start-1">
            <div className="relative">
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto border shadow-lg"
                src="/images/offerte3.jpg"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20 md:order-none">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Groepenkast vervangen of aansluiten? Veilig, snel en
              professioneel!
            </h2>

            <p className="mb-6">
              Een moderne en veilige groepenkast is de basis van een betrouwbare
              elektrische installatie. Of u nu een nieuwe groepenkast nodig
              heeft of uw oude groepenkast wilt vervangen, bij Elektra Aanleggen
              bent u verzekerd van een vakkundige installatie door
              InstalQ-geregistreerde elektriciens. Wij werken altijd volgens de
              nieuwste NEN 1010 & NEN 3140 normen, zodat u verzekerd bent van
              een veilige, toekomstbestendige groepenkast. Verouderde
              groepenkasten kunnen storingen, overbelasting en zelfs brandgevaar
              veroorzaken. Daarom is het essentieel om tijdig te kiezen voor een
              groepenkast vervangen met aardlekbeveiliging en hoofdschakelaar.
              Wij regelen alles: van extra groepen voor inductie, zonnepanelen
              en laadpalen tot een volledige vervanging inclusief meterkast
              upgrade.
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  InstalQ-geregistreerd & gecertificeerde elektriciens –
                  Betrouwbaar en deskundig
                </span>
              </li>

              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  8 jaar garantie op materiaal en installatie
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Zegelgerechtigde elektriciens – Wij mogen officiële
                  verzegelingen verbreken en herstellen
                </span>
              </li>
            </ul>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/kookgroep-aansluiten"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Meer over kookgroep
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>

          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                decoding="async"
                data-nimg="1"
                src="/images/ABB.png"
                srcSet="/images/ABB.png"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>

        <ServicesOverview />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Kookgroep en Perilex aansluiten? Veilig en vakkundig geregeld!
            </h2>

            <p className="mb-6">
              Wilt u overstappen op een inductiekookplaat? Dan heeft u een
              speciale kookgroep en een Perilex-aansluiting nodig voor een
              stabiele en veilige stroomvoorziening. Bij Elektra Aanleggen bent
              u verzekerd van een professionele installatie. Wij werken volgens
              de NEN 1010 & NEN 3140 normen, zodat u zorgeloos en energiezuinig
              kunt koken zonder storingen of overbelasting. Een
              inductiekookplaat gebruikt meer vermogen dan een standaard
              kooktoestel. Een gewone wandcontactdoos is hier niet voor geschikt
              en kan oververhitting en stroomstoringen veroorzaken. Met een
              extra kookgroep en een Perilex-aansluiting wordt de stroomtoevoer
              gescheiden en optimaal verdeeld, waardoor uw inductiekookplaat
              efficiënt en veilig functioneert.
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Snelle installatie – Vaak binnen één werkdag aangesloten
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Geschikt voor alle inductiekookplaten en Perilex-systemen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Veilig en volgens NEN 1010 & NEN 3140 normen geïnstalleerd
                </span>
              </li>
            </ul>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/kookgroep-aansluiten"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Meer over kookgroep
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                decoding="async"
                data-nimg="1"
                src="/images/perilex-kookplaat.png"
                srcSet="/images/perilex-kookplaat.png"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20 md:order-none">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              1-fase naar 3-fase groepenkast of groepenkast uitbreiden?
              Zorgeloos en veilig geregeld!
            </h2>

            <p className="mb-6">
              Heeft u een elektrische auto, inductiekookplaat of warmtepomp? Dan
              heeft u een 3-fase groepenkast nodig voor een stabiele en
              krachtige stroomvoorziening. Bij Elektra Aanleggen bent u
              verzekerd van een professionele installatie. Wij werken altijd
              volgens de NEN 1010 & NEN 3140 normen, zodat uw installatie
              voldoet aan de hoogste veiligheidseisen. Een 1-fase groepenkast
              upgraden naar 3-fase is essentieel als uw huidige installatie niet
              voldoende vermogen levert. Dit voorkomt overbelasting, uitvallende
              groepen en onnodige stroomstoringen. Wij verzorgen de complete
              installatie, zodat u direct probleemloos gebruik kunt maken van uw
              apparatuur.
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  InstalQ-geregistreerd & gecertificeerde elektriciens –
                  Deskundige en veilige installatie
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Zegelgerechtigde elektriciens – Officieel bevoegd om
                  verzegelingen te verbreken en herstellen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  8 jaar garantie op materiaal en installatie
                </span>
              </li>
            </ul>

            <div className="flex flex-wrap gap-3">
              <a
                href="/3-fase-aansluiting"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Meer over 3-fase aansluiting
                </span>
              </a>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>

          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                decoding="async"
                data-nimg="1"
                src="/images/ABB-440x390-3F.png"
                srcSet="/images/ABB-440x390-3F.png"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SmartHomeSection;
